import preferencesConfigAction from './preferencesConfig.action';

export default preferencesConfigAction;
